// LLM configuration — hardcoded
export const LLM_PROVIDER = 'deepseek';
export const LLM_API_KEY = 'sk-b2db0da266504ec4a7a7dff9954be385';
